import React from 'react'
import ResumeCheckbox from '../ResumeCheckbox'
import { connect } from "react-redux";
import { handlePhotoPrivacyHobby } from '../../../../services/actions/actions';

function ContentAboutme({personalDetail,handlePhotoPrivacy}) {
    const {photo,fullName,email,phone,city,country,postcode,address} = personalDetail
    return (
        <>
            <div className='contentaboutme'>
                <div className='ContentAboutme-container'>
                    <div className='ContentAboutme-displayPicture flex flex-col items-center border-b border-gray-300 py-2'>
                        <div className=' w-40 h-40 rounded-full overflow-hidden ring-1 ring-gray-200'>
                            <img src={photo.link} alt="profile" className='w-full h-full object-cover' />
                        </div>
                        <div>
                            <ResumeCheckbox value={photo.isHidden ? 'noshow' : 'show'} onChange={(e) => handlePhotoPrivacy(e.target.value)}/>
                        </div>
                    </div>
                    <div className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>Full name : </span>
                            <span>{fullName}</span>
                        </div>
                    </div>
                    <div className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>Email : </span>
                            <span>{email.emailDisplay}</span>
                        </div>
                        {/* <div>
                            <ResumeCheckbox value={email.isHidden ? 'noshow' : 'show'}/>
                        </div> */}
                    </div>
                    <div className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>Address : </span>
                            <span>{`${city}, ${postcode}, ${country}`}</span>
                        </div>
                        {/* <div>
                            <ResumeCheckbox value={address.isHidden ? 'noshow' : 'show'}/>
                        </div> */}
                    </div>
                    <div className='border-b border-gray-300 py-2'>
                        <div>
                            <span className='manpro font-semibold'>Phone : </span>
                            <span>{phone.phoneDisplay}</span>
                        </div>
                        {/* <div>
                            <ResumeCheckbox value={phone.isHidden ? 'noshow' : 'show'}/>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToState = (dispatch) => {
    return {
        handlePhotoPrivacy: (value) => {
            dispatch(handlePhotoPrivacyHobby(value))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToState)(ContentAboutme)